
//微信分享初始化
function shareInit(vm, { title = "", desc = "", imgurl = "" } = {}) {
    // console.log("分享初始化shareimageurl---", shareimageurl);
    vm.$kkmh.wxShare({
        title,
        desc,
        imgurl //默认用快看logo
    });
}

//分享
function share(vm, { title = "", desc = "", imgurl = "", sharetype = 0, shareimageurl = "" } = {}) {
    vm.$kkmh.nativeShare({
        //0：分享链接 1：分享图片
        sharetype: {
            qq: sharetype,
            moments: sharetype,
            weibo: sharetype,
            qqzone: sharetype,
            wechat: sharetype
        },
        shareimageurl,
        title,
        desc,
        imgurl,
        link: location.href,
        callback: function (res) {
            console.log("分享结果", res);
            if (res.errno == 0) {
                //分享成功
            } else if (res.errno == 1) {
                //分享失败
            }
        }
    });
}

export { shareInit, share }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/share.js